import React from 'react';

import { Helmet } from 'react-helmet';

import { Box, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import BundleForm from './components/BundleForm';

function BundlesCreate() {
  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>Create New Bundle</title>
      </Helmet>

      <PageHeader title="Create New Bundle" backButton="/cruises/bundles" />

      <Box mt={1}>
        <BundleForm />
      </Box>
    </Container>
  );
}

export default BundlesCreate;
